module.exports = __webpack_public_path__ + "static/media/ic-actions-trash.4a7aadb3.svg";